import { createSelector } from "reselect";

import { selectors as accSelectors } from "~/accordion";

import * as moduleSelectors from "../../selectors";

import * as cdSelectors from "~/customer-data/selectors";

import * as models from "./models";
import Immutable from "immutable";
import RootState from "~/types/store";

export const FIELD_LIST_KEY = "FIELD_LIST";

export const FIELDS_ACCORDION_KEY = "FIELDS_ACCORDION";
export const FIELD_LIST_ATTRS_KEY = "FIELD_LIST_ATTRS";

const getFieldListState = (state: RootState): models.IFieldListState =>
    moduleSelectors.getModuleState(state)[FIELD_LIST_KEY];

const getFieldListAttrsState = (state: RootState): models.IFieldListAttrsState =>
    getFieldListState(state)[FIELD_LIST_ATTRS_KEY];

const getAccordionState = (state: RootState): any => getFieldListState(state)[FIELDS_ACCORDION_KEY];

const getAccordionInit = (state: RootState): any => getFieldListAttrsState(state).accordionInit;

export const getAccordionId = (state: RootState) => getAccordionState(state).accordionId;
export const getAccordionItems = (state: RootState) =>
    accSelectors.itemsSelector(getAccordionState(state));
export const getAccordionItemsCount = (state: RootState) =>
    accSelectors.itemsSelector(getAccordionState(state)).length;
export const getAccordionRecHeight = (state: RootState) => getAccordionState(state).recHeight;
export const getAccordionRecItemCount = (state: RootState) => getAccordionState(state).recItemCount;
export const getCollapsingAll = (state: RootState): boolean =>
    getFieldListAttrsState(state).collapsingAll;
export const getDetailedFieldInfo = (state: RootState): any =>
    getFieldListAttrsState(state).detailedFieldInfo;
export const getDimIdxMap = (state: RootState) =>
    accSelectors.dimIdxMapSelector(getAccordionState(state));
export const getExpandingAll = (state: RootState): boolean =>
    getFieldListAttrsState(state).expandingAll;
export const getFlatIdxMap = (state: RootState) =>
    accSelectors.flatIdxMapSelector(getAccordionState(state));
export const getBatchFieldDetails = (state: RootState): any =>
    getFieldListAttrsState(state).batchFieldDetails;
export const getBatchFieldRemovalDetails = (state: RootState): any =>
    getFieldListAttrsState(state).batchFieldRemovalDetails;
export const getManualExpandedCustomers = (state: RootState): Immutable.Set<string> =>
    getFieldListAttrsState(state).manualExpandedCustomers;
export const getFilterOptions = (state: RootState): any =>
    getFieldListAttrsState(state).filterOptions;
export const getFilterSelections = (state: RootState): models.IFieldFilterSelections =>
    getFieldListAttrsState(state).filterSelections;
export const getFilterCount = (state: RootState): any => getFieldListAttrsState(state).filterCount;
export const getShowBatchEdit = (state: RootState): any =>
    getFieldListAttrsState(state).showBatchEdit;
export const getShowFilters = (state: RootState): any => getFieldListAttrsState(state).showFilters;
export const getSearchValue = (state: RootState): any => getFieldListAttrsState(state).searchValue;

export const getAllExpandedCustomers = createSelector(
    getManualExpandedCustomers,
    cdSelectors.getAutoExpandedCustomers,
    (manualExpandedCustomers, autoExpandedCustomers) =>
        manualExpandedCustomers.concat(autoExpandedCustomers)
);

export const getAccordionScrollTop = createSelector(
    getAccordionInit,
    (accordionInit) => accordionInit.initScrollTop
);

export const getAccordionScrollToFlatIdx = createSelector(
    getAccordionInit,
    (accordionInit) => accordionInit.scrollToFlatIdx
);

export const getLastClickedDimIdx = createSelector(
    getAccordionInit,
    (accordionInit) => accordionInit.lastClickedDimIdx
);
